module.exports = __webpack_public_path__ + "img/cargo-wagon-door-horizontal-side-mask.25a9023b.png";